module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#gallery",
      toString: function () {
        return this.url;
      }
    }